module.exports = __webpack_public_path__ + "img/21DayFixUltimate.ed55635a.jpg";